import { render, staticRenderFns } from "./ProjectListPanel.vue?vue&type=template&id=51c6c40a&scoped=true&lang=pug&"
import script from "./ProjectListPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListPanel.vue?vue&type=style&index=0&id=51c6c40a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6c40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VList,VListTile,VListTileAction,VListTileAvatar,VListTileContent,VListTileTitle})
